<template>
        <transition name="modal">
            <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                <div class="modal-header">
                    <slot name="header">
                      <b-img style="margin: 15px; height: 100px; width: 100px" src="" />
                      <br>
                      <h2>{{ this.HeaderTitle }}</h2>
                    </slot>
                </div>

                <div class="modal-body">
                    <slot name="body">
                        <label>Name</label>
                        <b-input v-model="Name"></b-input>
                      <br>
                      <label>Employee Image</label>
                      <picture-input
                            ref="pictureInput"
                            @change="onLogoChanged"
                            @remove="onLogoRemoved"
                            :width="500"
                            :removable="false"
                            removeButtonClass="btn btn-danger"
                            :height="200"
                            accept="image/jpeg"
                            buttonClass="btn btn-primary"
                            :customStrings="{
                            upload: '<h1>Jetzt hochladen</h1>',
                            drag: 'Drag and drop your image here'}">
                        </picture-input>
                    </slot>
                    
                </div>

                <div class="modal-footer">
                    <slot name="footer">
                    <button class="btn btn-danger" @click="$emit('close')">
                        Abbrechen
                    </button>
                    <button class="btn btn-success" @click="save">
                        OK
                    </button>
                    </slot>
                </div>
                </div>
            </div>
            </div>
        </transition>

</template>


<script>

import '../assets/demo.css'
import '../assets/light-bootstrap-dashboard.css'

export default {
  name: "EmployeeModal",
  props: ["Employee", "HeaderTitle", "InitName"],
  components: {
  },
  watch:
  {
    InitName: function()
    {
      this.Name = this.InitName;
    }
  },
  data() {
    return {
      customizeData : {},
      Name : this.InitName
    };
  },
  methods: {
    onLoad: function() {


    },
    onLogoChanged() {
      if (this.$refs.pictureInput.file) 
      {
        var image = this.$refs.pictureInput.file;
        var formData = new FormData();
        formData.append('image', image, this.Employee.PictureName + ".jpg");
        formData.append("companyID", this.Employee.CompanyID);
        
        console.log(process.env.NOACCESSURL);

        this.$http.post(process.env.NOACCESSURL + 'uploadEmployeeImage.php?'
        + "&imageName=" + this.Employee.PictureName, 
            formData, {
                'Content-Type': 'multipart/form-data'
            }).then(
            response => {
                console.log(response.body);
            },
            response => {

            }
        );

      } else {
      console.log("Old browser. No support for Filereader API");
      }
    },
    onLogoRemoved()
    {

    },
    save() 
    {
      var formData = new FormData();

      formData.append("Name", this.Name);
      formData.append("EmployeeID", this.Employee.EmployeeID);
      
      this.$http.post(process.env.NOACCESSURL + 'updateEmployeeData.php', formData).then(
          response => 
          {
              this.$emit('employeeSaved');
          },
          response => {

          }
      );
    }
   
  },
  beforeMount() {
    this.onLoad();
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
    
  }
  
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  
  .modal-container {
    width: 50%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    
  }
  
  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }
  
  .modal-body {
    margin: 20px 0;
    text-align:left;
    height: 400px;
    overflow: auto;
  }
  
  .modal-default-button {
    float: right;
  }
  
  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */
  
  .modal-enter {
    opacity: 0;
  }
  
  .modal-leave-active {
    opacity: 0;
  }
  
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }


</style>



// WEBPACK FOOTER //
// src/components/EmployeeModal.vue